import Tracking from '@/helpers/tracking/Tracking';
import {
  LS_BI_TRACKING_CID,
  LS_BI_TRACKING_LANDINGPAGEREFERRER,
  LS_BI_TRACKING_REFERRER,
} from '@/constants/storage';

export function getPageUrl() {
  let pageUrl = window.location.href.split('#')[0];
  const origReferrer = window.location.href.split('orig_referrer=');
  if (origReferrer.length > 1) {
    // eslint-disable-next-line prefer-destructuring
    pageUrl = origReferrer[0];
  }

  return cleanUrl(pageUrl);
}

function cleanUrl(url) {
  if (url.match('/ey')) {
    let cleanUrl = url.split('/ey');
    url = cleanUrl[0];
  }
  return url;
}

export function setReferrer() {
  const referrer = getUrlParam('referrer');
  if (referrer) {
    localStorage.setItem(LS_BI_TRACKING_REFERRER, referrer);
  }
  return referrer;
}
export function getUrlParam(searchKey) {
  const allParams = new URLSearchParams(window.location.search);
  let param;
  for (const [key, value] of allParams) {
    if (key.toUpperCase() === searchKey.toUpperCase()) {
      param = value;
    }
  }
  return param;
}

export function setLandingPageReferrer() {
  const landingPageReferrer = getUrlParam('landingpagereferrer');
  if (landingPageReferrer) {
    localStorage.setItem(LS_BI_TRACKING_LANDINGPAGEREFERRER, landingPageReferrer);
  }
  return landingPageReferrer;
}

export function setCid() {
  const cid = getUrlParam('CID');
  if (cid) {
    localStorage.setItem(LS_BI_TRACKING_CID, cid);
  }
  return cid;
}

/**
 *
 * @param obj {object}
 * @returns {FormData}
 */
export function objectToFormData(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach((item) => {
    formData.append(item, obj[item]);
  });
  return formData;
}

/**
 *
 * @param key {string}
 * @param sourceURL {string}
 *
 * @returns {string}
 */
export function removeParamFromUrl(key, sourceURL) {
  const queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  let rtn = sourceURL.split('?')[0];
  let param;
  let paramsArr = [];

  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      // eslint-disable-next-line prefer-destructuring
      param = paramsArr[i].split('=')[0];
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = `${rtn}?${paramsArr.join('&')}`;
  }
  return rtn;
}

export function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getBrowser() {
  const useragent = navigator.userAgent;
  let tem;
  let browser =
    useragent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(browser[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(useragent) || [];
    return `IE${tem[1]}`;
  }

  if (browser[1] === 'Chrome') {
    tem = useragent.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem !== null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  browser = browser[2] ? [browser[1], browser[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if (useragent.match(/version\/(\d+)/i) !== null) {
    tem = useragent.match(/version\/(\d+)/i);
    browser.splice(1, 1, tem[1]);
  }
  return browser;
}

export function scrollToElem(elem, headerSelector = 'header.section-header') {
  const headerEl = document.querySelector(headerSelector);
  const yOffset = -10;

  let y = elem.getBoundingClientRect().top + window.pageYOffset + yOffset;
  if (typeof headerEl !== 'undefined' && headerEl !== null) {
    if (window.getComputedStyle(headerEl).getPropertyValue('position') === 'fixed') {
      y -= headerEl.clientHeight;
    }
  }

  if (getBrowser() === 'IE11') {
    // IE11 doesn't like scrollTo with options
    window.scrollTo(0, y);
  } else {
    window.setTimeout(() => {
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    }, 100);
  }
}

export function isProd() {
  return window.location.origin === 'https://meine.pflege.de';
}

export function createTrackingData(product, label, eventElement, eventAction = '-click') {
  Tracking.trackDatalayer({
    product: product,
    category: 'DPA',
    event: eventElement + eventAction,
    label: trimLabelText(label),
  });
}

export function trimLabelText(labelText) {
  labelText = labelText.replace(' ({value})', '');
  labelText = labelText.replace(/[()]/g, '');
  return labelText;
}
